import { PaymentBuilder, TenderType } from '@symphony-solo/domain/payments/src';
import { TransactionLineTenderDto } from '../dtos';

export class TransactionLineTenderBuilder {
  private transactionLineTender: TransactionLineTenderDto;

  constructor() {
    this.transactionLineTender = new TransactionLineTenderDto();
  }

  public setTenderType(type: TenderType): TransactionLineTenderBuilder {
    this.transactionLineTender.tenderType = type;
    return this;
  }

  public setTenderedPayment(id: number, name: string): TransactionLineTenderBuilder {
    const payment = new PaymentBuilder()
      .setId(id)
      .setName(name)
      .build();
    this.transactionLineTender.tenderedPayment = payment;
    return this;
  }

  public setTenderedAmount(tenderedAmount: number): TransactionLineTenderBuilder {
    this.transactionLineTender.tenderedAmount = tenderedAmount;
    return this;
  }

  public setChangePayment(id: number, name: string): TransactionLineTenderBuilder {
    const payment = new PaymentBuilder()
      .setId(id)
      .setName(name)
      .build();
    this.transactionLineTender.changePayment = payment;
    return this;
  }

  public setChangeAmount(changeAmount: number): TransactionLineTenderBuilder {
    this.transactionLineTender.changeAmount = changeAmount;
    return this;
  }

  public build(): TransactionLineTenderDto {
    return this.transactionLineTender;
  }
}
